var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { Link } from '../../../Link';
var StyledCustomLink = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 12px;\n  font-size: 0.813rem;\n  display: inline-block;\n"], ["\n  margin-bottom: 12px;\n  font-size: 0.813rem;\n  display: inline-block;\n"])));
/**
 * This component renders a link below the slider items.
 *
 * It is initially used for the usecase, where the ProductRecoSlider can have an optional link,
 * which redirects to an MBA to show more articles. (Lookup PACE-707 Ticket for more info)
 */
var CustomLink = function (_a) {
    var _b = _a.text, text = _b === void 0 ? '' : _b, to = _a.to;
    if (!to) {
        return null;
    }
    if (to && !text) {
        console.error('Slider - CustomLink: No text for the link was provided');
        return null;
    }
    return (React.createElement(StyledCustomLink, { solo: true, to: to, "data-testid": "custom-link" }, text));
};
export default CustomLink;
var templateObject_1;
//# sourceMappingURL=index.js.map